import { GeoService, getAdditionalHeaders, SearchRequest, SearchResponse, SearchTaskResponse } from "@esignal/polygon-service-api";
import axios, { AxiosInstance, CreateAxiosDefaults } from "axios";

export class GeoServiceImpl implements GeoService {
	private aInstance: AxiosInstance;
	public constructor(baseURL: string = "/geoservice/api/v1/") {
		const config: CreateAxiosDefaults = {
			headers: {
				"Content-Type": "application/json",
			},
		};
		if (baseURL) {
			const hns = typeof location === "object" ? location.hostname?.split(".") : undefined;
			if (hns && hns.length >= 3) {
				const url = new URL(location.toString());
				hns.shift();
				hns.unshift("auth");
				url.hostname = hns.join(".");
				url.pathname = baseURL;
				config.baseURL = url.toString();
				console.warn("Using " + config.baseURL);
			} else {
				config.baseURL = baseURL;
			}
		}
		this.aInstance = axios.create(config);
	}

	public initialize(): void {}

	async status(): Promise<string> {
		const { data } = await this.aInstance.post("status", {}, { headers: { "Content-type": "text/plain" } });
		return data;
	}

	async version(): Promise<string> {
		const { data } = await this.aInstance.post("version", {}, { headers: { "Content-type": "text/plain" } });
		return data;
	}

	async search(request: SearchRequest): Promise<SearchResponse> {
		const { data } = await this.aInstance.post("search", request);
		return data;
	}

	async search_list(request: SearchRequest): Promise<SearchResponse> {
		const { data } = await this.aInstance.post("search_list", request);
		return data;
	}

	async search_task_create(request: SearchRequest): Promise<SearchTaskResponse> {
		console.debug("search_task_create", request);
		const { data } = await this.aInstance.post("search_task", request, { headers: getAdditionalHeaders() });
		console.log("search_task_create response", data);
		return data;
	}

	async search_task(requestId: string): Promise<SearchResponse> {
		console.debug("search_task", requestId);
		const { data } = await this.aInstance.post(`search_task/${requestId}`, {}, { headers: getAdditionalHeaders() });
		console.log("search_task responseeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee ", data);
		return data;
	}
}
